module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_quests_big_cn.28f8da47.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_quests_big_cn.jpg
// module id = 2988
// module chunks = 11